import { call, put, takeLatest } from "redux-saga/effects";
import { VOUCHER_REDEMPTION_CLAIM_ACTION } from "./actionType";
import { VoucherRedemptionClaim_Action_Success, VoucherRedemptionClaim_ErrorAction } from "./action";
import { VoucherRedemption_Aip } from "../../../helpers/backend_helper";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { numberWithCommas } from "../../../Reports/Report_common_function";


function* VoucherRedemptionClaim_GenFunc({ config }) {

	function formatDateRange(dateRange) {
		if (!dateRange || !dateRange.includes(" To ")) {
		  return ""; // or return "Invalid date range"
		}
	  
		const [start, end] = dateRange.split(" To ");
	  
		const formatDate = (dateStr) => {
		  const [year, month, day] = dateStr.split("-");
		  return `${day}-${month}-${year}`;
		};
	  
		return `${formatDate(start)} To ${formatDate(end)}`;
	  }
	try {
		const response = yield call(VoucherRedemption_Aip, config);

		if ((response.Status === true) && (response.StatusCode === 204)) {
			customAlert({
				Type: 3,
				Message: response.Message,
			})
			yield put(VoucherRedemptionClaim_Action_Success([]))
			return
		}

		const transformedData = response?.Data.map(item => ({
			...item,
			TotalClaimAmount: numberWithCommas(Number(item.TotalClaimAmount).toFixed(2)),
			recordsAmountTotal: item.TotalClaimAmount,
			SchemePeriod: formatDateRange(item.SchemePeriod),
		}));

		yield put(VoucherRedemptionClaim_Action_Success(transformedData))
	} catch (error) { yield put(VoucherRedemptionClaim_ErrorAction()) }
}

function* VoucherRedemptionClaimSaga() {
	yield takeLatest(VOUCHER_REDEMPTION_CLAIM_ACTION, VoucherRedemptionClaim_GenFunc)

}

export default VoucherRedemptionClaimSaga;
